const es = {
    DROPDOWN_OPTIONS_ERASE_ALL: 'Borrar todo',
    DROPDOWN_OPTIONS_BACK_BUTTON: 'Regresar',
    DROPDOWN_EMPTY_TITLE: 'No se encontraron resultados',
    DROPDOWN_EMPTY_SUBTITLE: 'Prueba palabras clave más generales',
    DROPDOWN_SEARCH_PLACEHOLDER: 'Buscar',
    DROPDOWN_LOADING: 'Cargando...',
    DROPDOWN_ERROR_TITLE: 'Error al cargar datos',
    DROPDOWN_ERROR_DESCRIPTION: 'Hubo un problema al cargar la información. Por favor, intenta nuevamente.',
    DROPDOWN_ERROR_RETRY: 'Reintentar'
};
const localeEs = es;
export default localeEs;
